import type * as registerWin32Icons20px from './registerWin32Icons20px';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule20px: LazyModule<typeof registerWin32Icons20px> = new LazyModule(
    () => import(/* webpackChunkName: "Win32Icons20px" */ './registerWin32Icons20px'),
    { name: 'Win32Icons20px' }
);

export const lazyRegisterWin32Icons20px: LazyAction<
    typeof registerWin32Icons20px.registerWin32Icons20px,
    typeof lazyModule20px
> = new LazyAction(lazyModule20px, module => module.registerWin32Icons20px);
